
type Props = {}

const TabPhieuChiDinh = (props: Props) => {
  return (
    <div>TabPhieuChiDinh</div>
  )
}

export default TabPhieuChiDinh